export const rowsPerPage = 10

export const rowHeight = 53

export const defaultProps = {
  error: false,
  loading: false,
  competitors_adjusted: [
    {
      mutual_prospect_count: 11,
      name: 'Temple University',
      sc_id: 1100189,
      total_prospect_count: 19,
    },
    {
      mutual_prospect_count: 13,
      name: 'West Chester University of Pennsylvania',
      sc_id: 1100267,
      total_prospect_count: 51,
    },
    {
      mutual_prospect_count: 4,
      name: 'Rochester Institute of Technology',
      sc_id: 1100157,
      total_prospect_count: 8,
    },
    {
      mutual_prospect_count: 3,
      name: 'Adrian College',
      sc_id: 1100983,
      total_prospect_count: 4,
    },
    {
      mutual_prospect_count: 3,
      name: 'Alabama State University',
      sc_id: 2400002,
      total_prospect_count: 4,
    },
    {
      mutual_prospect_count: 3,
      name: 'Adirondack Community College',
      sc_id: 7000710,
      total_prospect_count: 3,
    },
    {
      mutual_prospect_count: 2,
      name: 'Aberystwyth University',
      sc_id: 6000195,
      total_prospect_count: 4,
    },
    {
      mutual_prospect_count: 2,
      name: 'Cornell University',
      sc_id: 1100516,
      total_prospect_count: 4,
    },
    {
      mutual_prospect_count: 2,
      name: 'Abraham Baldwin Agricultural College',
      sc_id: 5000170,
      total_prospect_count: 3,
    },
    {
      mutual_prospect_count: 2,
      name: 'Alabama Southern Community College',
      sc_id: 7000101,
      total_prospect_count: 3,
    },
    {
      mutual_prospect_count: 2,
      name: 'American University in Cairo',
      sc_id: 1100023,
      total_prospect_count: 3,
    },
  ],
  competitors: [
    {
      mutual_prospect_count: 13,
      name: 'West Chester University of Pennsylvania',
      sc_id: 1100267,
      total_prospect_count: 51,
    },
    {
      mutual_prospect_count: 11,
      name: 'Temple University',
      sc_id: 1100189,
      total_prospect_count: 19,
    },
    {
      mutual_prospect_count: 4,
      name: 'Rochester Institute of Technology',
      sc_id: 1100157,
      total_prospect_count: 8,
    },
    {
      mutual_prospect_count: 3,
      name: 'Adirondack Community College',
      sc_id: 7000710,
      total_prospect_count: 3,
    },
    {
      mutual_prospect_count: 3,
      name: 'Adrian College',
      sc_id: 1100983,
      total_prospect_count: 4,
    },
    {
      mutual_prospect_count: 3,
      name: 'Alabama State University',
      sc_id: 2400002,
      total_prospect_count: 4,
    },
    {
      mutual_prospect_count: 2,
      name: 'Aaniiih Nakoda College',
      sc_id: 7000639,
      total_prospect_count: 2,
    },
    {
      mutual_prospect_count: 2,
      name: 'Aberystwyth University',
      sc_id: 6000195,
      total_prospect_count: 4,
    },
    {
      mutual_prospect_count: 2,
      name: 'Abraham Baldwin Agricultural College',
      sc_id: 5000170,
      total_prospect_count: 3,
    },
    {
      mutual_prospect_count: 2,
      name: 'Adelphi University',
      sc_id: 1100006,
      total_prospect_count: 2,
    },
    {
      mutual_prospect_count: 2,
      name: 'Adventist University of Health Sciences',
      sc_id: 5000135,
      total_prospect_count: 2,
    },
  ],
}
